import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddAttributeAnswer } from '../../projectDetailsActivities.models';

export const AddAttributeAnswerActivity = ({ values }: IProjectActivity<IProjectActivityAddAttributeAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.addAnswer')}
      <b>{values.answer}</b> {t('activity_description_common.to')} {t('activity_description_common.question')} <b>{values.attribute}</b>.
    </span>
  );
};
